enum ViewScreenKey {
    Home = "Home",
    Measurement = "Measurement",
    Result = "Result",
    Info = "Info",
}

export default ViewScreenKey;